module.exports = __webpack_public_path__ + "d0558d91063038236b60e3ef71fdc1fd.svg";


//////////////////
// WEBPACK FOOTER
// ./static/badge/ios/EN.svg
// module id = 3158
// module chunks = 0